// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const DeckBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 100 60" {...props}>
    <path
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9 16h28v28H9zM41.5 16h28v28h-28zM91 16H74v27.9h17"
    />
  </svg>
);

export default DeckBlock;
